// Module
var code = "\n    <div class=\"item-name\">${Item.Label}</div>\n    <div class=\"validation-error\"></div>\n";
// Exports
var htmlContent = code;
jQuery.templatesHtml['#edit-record-field-label'] = htmlContent;
module.exports = "edit-record-field-label";